import { useState } from "react";

const INIT_FILES = [
  { id:1,  admission_no:"IPD20260001", patient_name:"Nikhil Gornod", patient_phone:"9876543210",
    file_name:"CBC_Report_NikhilGornod_01Apr.pdf",     file_type:"Lab Result",
    reference_type:"lab_order_item", reference_id:1,
    file_url:"patient_files/cbc_nikhil_01apr.pdf",
    file_size:"245 KB", file_ext:"pdf",
    uploaded_by_name:"Lab Tech Ramesh", uploaded_at:"2026-04-01 12:30",
    notes:"CBC result — WBC elevated", clinic_title:"MediCure Health Center" },

  { id:2,  admission_no:"IPD20260001", patient_name:"Nikhil Gornod", patient_phone:"9876543210",
    file_name:"ChestXRay_NikhilGornod_01Apr.jpg",      file_type:"Radiology Report",
    reference_type:"radiology_order_item", reference_id:1,
    file_url:"patient_files/cxr_nikhil_01apr.jpg",
    file_size:"1.2 MB", file_ext:"jpg",
    uploaded_by_name:"Dr. Radha Sharma", uploaded_at:"2026-04-01 13:00",
    notes:"Chest X-Ray PA view — clear", clinic_title:"MediCure Health Center" },

  { id:3,  admission_no:"IPD20260001", patient_name:"Nikhil Gornod", patient_phone:"9876543210",
    file_name:"USG_Abdomen_NikhilGornod_01Apr.pdf",    file_type:"Radiology Report",
    reference_type:"radiology_order_item", reference_id:2,
    file_url:"patient_files/usg_nikhil_01apr.pdf",
    file_size:"890 KB", file_ext:"pdf",
    uploaded_by_name:"Dr. Radha Sharma", uploaded_at:"2026-04-01 14:00",
    notes:"USG Abdomen — mild hepatomegaly", clinic_title:"MediCure Health Center" },

  { id:4,  admission_no:"IPD20260001", patient_name:"Nikhil Gornod", patient_phone:"9876543210",
    file_name:"DischargeSummary_IPD20260001.pdf",      file_type:"Discharge Summary",
    reference_type:"ipd_admission", reference_id:1,
    file_url:"patient_files/discharge_nikhil.pdf",
    file_size:"320 KB", file_ext:"pdf",
    uploaded_by_name:"Admin User", uploaded_at:"2026-04-07 17:00",
    notes:null, clinic_title:"MediCure Health Center" },

  { id:5,  admission_no:"IPD20260002", patient_name:"Ritu Sharma",   patient_phone:"9876501234",
    file_name:"CTScan_Abdomen_RituSharma_03Apr.pdf",   file_type:"Radiology Report",
    reference_type:"radiology_order_item", reference_id:3,
    file_url:"patient_files/ct_ritu_03apr.pdf",
    file_size:"4.5 MB", file_ext:"pdf",
    uploaded_by_name:"Dr. Radha Sharma", uploaded_at:"2026-04-04 09:00",
    notes:"CT Abdomen — no free air, appendix visualised", clinic_title:"MediCure Health Center" },

  { id:6,  admission_no:"IPD20260002", patient_name:"Ritu Sharma",   patient_phone:"9876501234",
    file_name:"LFT_RituSharma_03Apr.pdf",              file_type:"Lab Result",
    reference_type:"lab_order_item", reference_id:5,
    file_url:"patient_files/lft_ritu_03apr.pdf",
    file_size:"180 KB", file_ext:"pdf",
    uploaded_by_name:"Lab Tech Ramesh", uploaded_at:"2026-04-04 10:30",
    notes:null, clinic_title:"MediCure Health Center" },

  { id:7,  admission_no:"IPD20260002", patient_name:"Ritu Sharma",   patient_phone:"9876501234",
    file_name:"ConsentForm_Surgery_RituSharma.pdf",    file_type:"Consent Form",
    reference_type:"ipd_admission", reference_id:2,
    file_url:"patient_files/consent_ritu.pdf",
    file_size:"95 KB", file_ext:"pdf",
    uploaded_by_name:"Admin User", uploaded_at:"2026-04-03 07:45",
    notes:"Signed consent for laparoscopic appendectomy", clinic_title:"MediCure Health Center" },

  { id:8,  admission_no:"IPD20260003", patient_name:"Arjun Patel",   patient_phone:"9812345678",
    file_name:"WoundPhoto_ArjunPatel_05Apr.jpg",       file_type:"Clinical Photo",
    reference_type:"ipd_admission", reference_id:3,
    file_url:"patient_files/wound_arjun_05apr.jpg",
    file_size:"2.1 MB", file_ext:"jpg",
    uploaded_by_name:"Dr. Anjali Singh", uploaded_at:"2026-04-05 11:00",
    notes:"Pre-debridement wound photo", clinic_title:"VitalCare Clinic" },

  { id:9,  admission_no:"IPD20260003", patient_name:"Arjun Patel",   patient_phone:"9812345678",
    file_name:"CBC_PreOp_ArjunPatel_04Apr.pdf",        file_type:"Lab Result",
    reference_type:"lab_order_item", reference_id:6,
    file_url:"patient_files/cbc_arjun_04apr.pdf",
    file_size:"210 KB", file_ext:"pdf",
    uploaded_by_name:"Lab Tech Suresh", uploaded_at:"2026-04-04 09:30",
    notes:"Pre-op CBC — Hb low, noted", clinic_title:"VitalCare Clinic" },

  { id:10, admission_no:"IPD20260004", patient_name:"Meena Joshi",   patient_phone:"9700012345",
    file_name:"MRI_Brain_MeenaJoshi_06Apr.pdf",        file_type:"Radiology Report",
    reference_type:"radiology_order_item", reference_id:7,
    file_url:"patient_files/mri_meena_06apr.pdf",
    file_size:"8.2 MB", file_ext:"pdf",
    uploaded_by_name:"Dr. Radha Sharma", uploaded_at:"2026-04-07 15:00",
    notes:"MRI Brain — no focal lesion", clinic_title:"MediCure Health Center" },
];

const FILE_TYPES = ["All", "Lab Result", "Radiology Report", "Discharge Summary", "Consent Form", "Clinical Photo", "Prescription", "Insurance Document", "Other"];

const FILE_TYPE_STYLE = {
  "Lab Result":           { bg:"rgba(245,158,11,.12)",  color:"#f59e0b",  icon:"🧪" },
  "Radiology Report":     { bg:"rgba(8,145,178,.12)",   color:"#0891b2",  icon:"🩻" },
  "Discharge Summary":    { bg:"rgba(16,185,129,.12)",  color:"#10b981",  icon:"📋" },
  "Consent Form":         { bg:"rgba(124,58,237,.12)",  color:"#7c3aed",  icon:"✍️" },
  "Clinical Photo":       { bg:"rgba(236,72,153,.12)",  color:"#ec4899",  icon:"📷" },
  "Prescription":         { bg:"rgba(59,130,246,.12)",  color:"#3b82f6",  icon:"💊" },
  "Insurance Document":   { bg:"rgba(107,114,128,.12)", color:"#9ca3af",  icon:"🛡️" },
  "Other":                { bg:"rgba(107,114,128,.12)", color:"#9ca3af",  icon:"📄" },
};

const EXT_ICON = {
  "pdf": "📄",
  "jpg": "🖼️",
  "jpeg":"🖼️",
  "png": "🖼️",
  "doc": "📝",
  "docx":"📝",
};

const mono = "'IBM Plex Mono',monospace";
const extIcon = e=>EXT_ICON[(e||"").toLowerCase()]||"📄";

const css=`
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
:root{--bg:#0A0C12;--bg2:#111318;--bg3:#181B24;--bg4:#1E2130;--border:#252836;--border2:#2E3348;--text:#EDF0FF;--muted:#6B7A99;--dim:#3D4563;--accent:#5E7BFF;--accent2:#8B9FFF;--green:#10B981;--red:#EF4444;--amber:#F59E0B;--blue:#3B82F6;}
body{background:var(--bg);color:var(--text);font-family:'IBM Plex Sans',sans-serif;min-height:100vh;}
.page{max-width:1200px;margin:0 auto;padding:24px 20px;}
.ph{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}
.ph-title{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;}
.ph-sub{font-size:12px;color:var(--muted);margin-top:2px;}
.sr{display:grid;gap:12px;margin-bottom:20px;}
.sc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:16px 18px;}
.sl{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;margin-bottom:6px;}
.sv{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;}
.sb{height:3px;border-radius:2px;margin-top:8px;}
.fb{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:12px 16px;display:flex;gap:10px;align-items:center;margin-bottom:14px;flex-wrap:wrap;}
.sw{position:relative;flex:1;min-width:180px;}
.si{position:absolute;left:10px;top:50%;transform:translateY(-50%);color:var(--muted);font-size:13px;pointer-events:none;}
.input{width:100%;padding:8px 12px;border-radius:8px;border:1px solid var(--border2);background:var(--bg3);color:var(--text);font-size:12px;font-family:'IBM Plex Sans',sans-serif;outline:none;transition:border-color .15s;}
.input:focus{border-color:var(--accent);}
.sip{padding-left:32px;}
.sel{appearance:none;cursor:pointer;}
.chip{display:inline-flex;align-items:center;padding:2px 8px;border-radius:6px;font-size:10px;font-weight:600;}
.ib{width:26px;height:26px;border-radius:6px;border:1px solid var(--border2);background:transparent;color:var(--muted);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11px;transition:all .15s;flex-shrink:0;}
.ib:hover{border-color:var(--accent2);color:var(--accent2);}
.ib.d:hover{border-color:#ef4444;color:#ef4444;}
.fc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:13px 16px;display:flex;align-items:flex-start;gap:13px;margin-bottom:9px;transition:border-color .15s;}
.fc:hover{border-color:var(--border2);}
.fci{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;}
.btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;font-size:12px;font-weight:500;cursor:pointer;border:none;font-family:'IBM Plex Sans',sans-serif;transition:all .15s;}
.bp{background:var(--accent);color:#fff;}
.bp:hover{background:#4a67e8;}
.bp:disabled{opacity:.5;cursor:not-allowed;}
.bg_{background:var(--bg3);color:var(--text);border:1px solid var(--border2);}
.bg_:hover{border-color:var(--accent2);}
.empty{padding:40px;text-align:center;color:var(--muted);}
.mb{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:50;display:flex;align-items:center;justify-content:center;padding:20px;}
.mx{background:var(--bg2);border:1px solid var(--border2);border-radius:16px;padding:28px;width:100%;max-width:560px;max-height:90vh;overflow-y:auto;}
.mt{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;margin-bottom:18px;display:flex;align-items:center;justify-content:space-between;}
.mg{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;}
.mf{grid-column:1/-1;}
.field{display:flex;flex-direction:column;gap:5px;}
.field label{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;}
.ta{resize:vertical;min-height:70px;}
.ma{display:flex;gap:8px;justify-content:flex-end;margin-top:16px;padding-top:14px;border-top:1px solid var(--border);}
.err{font-size:11px;color:#ef4444;margin-top:3px;}
.toast{position:fixed;bottom:24px;right:24px;background:var(--bg3);border:1px solid var(--border2);border-radius:10px;padding:12px 18px;display:flex;align-items:center;gap:10px;font-size:13px;font-weight:500;z-index:100;animation:su .25s ease;}
@keyframes su{from{transform:translateY(16px);opacity:0}to{transform:translateY(0);opacity:1}}
.dw{background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.2);border-radius:8px;padding:10px 14px;font-size:12px;color:#ef4444;margin-bottom:14px;}
.du{background:rgba(94,123,255,.08);border:1px dashed var(--border2);border-radius:10px;padding:18px;text-align:center;font-size:12px;color:var(--muted);margin-bottom:14px;}
`;

function Modal({title,onClose,children}){return(<div className="mb" onClick={onClose}><div className="mx" onClick={e=>e.stopPropagation()}><div className="mt">{title}<button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>{children}</div></div>);}

function DelModal({onClose,onConfirm,title,msg}){
  return(<Modal title="Confirm Delete" onClose={onClose}><div className="dw">⚠ {msg}</div><div style={{fontSize:13,color:"var(--muted)",marginBottom:14}}>{title}</div><div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn" style={{background:"rgba(239,68,68,.15)",color:"#ef4444",border:"1px solid rgba(239,68,68,.3)"}} onClick={onConfirm}>Yes, Delete</button></div></Modal>);
}

function UploadModal({onClose,onSave}){
  const [f,setF]=useState({admission_no:"",file_type:"Lab Result",file_name:"",patient_name:"",notes:""});
  const [errs,setErrs]=useState({});
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>{setF(p=>({...p,[k]:v}));setErrs(p=>({...p,[k]:""}));};
  const save=()=>{
    const e={};
    if(!f.admission_no.trim())e.admission_no="Required";
    if(!f.file_name.trim())e.file_name="Required";
    if(Object.keys(e).length){setErrs(e);return;}
    setSaving(true);
    const ext=(f.file_name.split(".").pop()||"pdf").toLowerCase();
    setTimeout(()=>onSave({...f,patient_name:f.patient_name.trim()||"—",file_ext:ext,notes:f.notes.trim()||null}),500);
  };
  return(
    <Modal title="Upload File" onClose={onClose}>
      <div className="du">⬆ Drag & drop or browse — <span style={{color:"var(--accent2)"}}>simulated upload</span> (no actual file is sent)</div>
      <div className="mg">
        <div className="field"><label>Admission No *</label><input className="input" value={f.admission_no} onChange={e=>set("admission_no",e.target.value)} placeholder="IPD…"/>{errs.admission_no&&<span className="err">{errs.admission_no}</span>}</div>
        <div className="field"><label>File Type *</label><select className="input sel" value={f.file_type} onChange={e=>set("file_type",e.target.value)}>{FILE_TYPES.slice(1).map(t=><option key={t}>{t}</option>)}</select></div>
        <div className="field mf"><label>File Name *</label><input className="input" value={f.file_name} onChange={e=>set("file_name",e.target.value)} placeholder="e.g. CBC_Report_Patient_01Apr.pdf"/>{errs.file_name&&<span className="err">{errs.file_name}</span>}</div>
        <div className="field mf"><label>Patient Name</label><input className="input" value={f.patient_name} onChange={e=>set("patient_name",e.target.value)} placeholder="Patient name"/></div>
        <div className="field mf"><label>Notes</label><textarea className="input ta" value={f.notes} onChange={e=>set("notes",e.target.value)} placeholder="Notes…" style={{minHeight:56}}/></div>
      </div>
      <div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn bp" onClick={save} disabled={saving}>{saving?"Uploading…":"Upload File"}</button></div>
    </Modal>
  );
}

export default function IpdFilesManagement(){
  const [files,setFiles]=useState(INIT_FILES);
  const [search,setSearch]=useState("");
  const [typeF,setTypeF]=useState("All");
  const [clinicF,setClinicF]=useState("All");
  const [from,setFrom]=useState("");
  const [to,setTo]=useState("");
  const [modal,setModal]=useState(null);
  const [upload,setUpload]=useState(false);
  const [toast,setToast]=useState(null);
  const close=()=>setModal(null);
  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(null),2500);};
  const clinics=["All",...new Set(files.map(f=>f.clinic_title))];

  const stats={
    total:files.length,
    lab:files.filter(f=>f.file_type==="Lab Result").length,
    radiology:files.filter(f=>f.file_type==="Radiology Report").length,
    other:files.filter(f=>f.file_type!=="Lab Result"&&f.file_type!=="Radiology Report").length,
  };

  const filtered=files.filter(f=>{
    const tf=typeF==="All"||f.file_type===typeF;
    const cf=clinicF==="All"||f.clinic_title===clinicF;
    const d=(f.uploaded_at||"").slice(0,10);
    const df=(!from||d>=from)&&(!to||d<=to);
    const q=!search||f.patient_name.toLowerCase().includes(search.toLowerCase())||f.admission_no.toLowerCase().includes(search.toLowerCase())||f.file_name.toLowerCase().includes(search.toLowerCase());
    return tf&&cf&&df&&q;
  });

  const handleDel=()=>{setFiles(fs=>fs.filter(f=>f.id!==modal.data.id));showToast("File deleted");close();};
  const handleUpload=form=>{
    setFiles(fs=>[{...form,id:Date.now(),reference_type:"ipd_admission",reference_id:null,file_url:`patient_files/${form.file_name}`,file_size:"— KB",uploaded_by_name:"Admin User",uploaded_at:new Date().toISOString().slice(0,16).replace("T"," "),clinic_title:"MediCure Health Center"},...fs]);
    showToast("File uploaded");setUpload(false);
  };

  return(<>
    <style>{css}</style>
    <div className="page">
      <div className="ph">
        <div><div className="ph-title">📁 IPD Files Management</div><div className="ph-sub">All patient documents across IPD admissions</div></div>
        <button className="btn bp" onClick={()=>setUpload(true)}>+ Upload File</button>
      </div>

      <div className="sr" style={{gridTemplateColumns:"repeat(4,1fr)"}}>
        {[{l:"Total Files",v:stats.total,c:"var(--accent2)",b:"rgba(94,123,255,.3)"},{l:"Lab Results",v:stats.lab,c:"var(--amber)",b:"rgba(245,158,11,.3)"},{l:"Radiology Reports",v:stats.radiology,c:"#22d3ee",b:"rgba(8,145,178,.3)"},{l:"Other Documents",v:stats.other,c:"var(--green)",b:"rgba(16,185,129,.3)"}].map(s=>(
          <div className="sc" key={s.l}><div className="sl">{s.l}</div><div className="sv" style={{color:s.c}}>{s.v}</div><div className="sb" style={{background:s.b}}/></div>
        ))}
      </div>

      <div className="fb">
        <div className="sw"><span className="si">🔍</span><input className="input sip" placeholder="Search patient, admission no or file name…" value={search} onChange={e=>setSearch(e.target.value)}/></div>
        <select className="input sel" style={{width:170}} value={typeF} onChange={e=>setTypeF(e.target.value)}>{FILE_TYPES.map(t=><option key={t}>{t}</option>)}</select>
        <select className="input sel" style={{width:180}} value={clinicF} onChange={e=>setClinicF(e.target.value)}>{clinics.map(c=><option key={c}>{c}</option>)}</select>
        <input className="input" type="date" style={{width:140}} value={from} onChange={e=>setFrom(e.target.value)} title="From date"/>
        <span style={{color:"var(--muted)",fontSize:11}}>–</span>
        <input className="input" type="date" style={{width:140}} value={to} onChange={e=>setTo(e.target.value)} title="To date"/>
        <span style={{fontSize:11,color:"var(--muted)"}}>{filtered.length} file{filtered.length!==1?"s":""}</span>
      </div>

      {filtered.length===0?<div className="empty">No files found</div>:filtered.map(f=>{
        const ft=FILE_TYPE_STYLE[f.file_type]||{bg:"var(--bg3)",color:"var(--muted)",icon:"📄"};
        return(
          <div className="fc" key={f.id}>
            <div className="fci" style={{background:ft.bg}}>{ft.icon}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                <span style={{fontSize:13,fontWeight:600}}>{extIcon(f.file_ext)} {f.file_name}</span>
                <span className="chip" style={{background:ft.bg,color:ft.color}}>{f.file_type}</span>
                <span className="chip" style={{background:"rgba(94,123,255,.1)",color:"var(--accent2)"}}>{f.admission_no}</span>
              </div>
              <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>{f.patient_name} · <span style={{fontFamily:mono}}>{f.patient_phone}</span> · uploaded by {f.uploaded_by_name} · {f.uploaded_at}</div>
              {f.notes&&<div style={{fontSize:11,color:"var(--muted)",fontStyle:"italic",marginTop:3}}>{f.notes}</div>}
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:7,flexShrink:0}}>
              <span style={{fontFamily:mono,fontSize:11,color:"var(--muted)"}}>{f.file_size}</span>
              <div style={{display:"flex",gap:4}}>
                <button className="ib" title="Download (simulated)" onClick={()=>showToast("Downloading…")}>⬇</button>
                <button className="ib d" onClick={()=>setModal({type:"del",data:f})}>🗑</button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
    {upload&&<UploadModal onClose={()=>setUpload(false)} onSave={handleUpload}/>}
    {modal?.type==="del"&&<DelModal onClose={close} onConfirm={handleDel} title={modal.data.file_name} msg="This will permanently delete the file record."/>}
    {toast&&<div className="toast"><span style={{color:"var(--green)",fontSize:16}}>✓</span>{toast}</div>}
  </>);
}
